import React, { useCallback, useState } from "react";
import useSWR from "swr";
import VerbatimCard from "./VerbatimCard";
import { fetcher, commentsFetcher } from "../../../../utils/request";
import constants from "../../../../config/constants";
import ShareModal from "../../../common/ShareModal";
import Modal from "../../../common/Modal";
import FeedbackForm from "../../../layout/FeedbackForm";
import FeedbackBanner from "../../../common/FeedbackBanner";

const RightPanel = ({ content, book, isAuthenticated, openSideBar }) => {
  const [isShareModalVisible, setIsShareModalVisible] = useState(false);
  const [showFeedbackAlert, setShowFeedbackAlert] = useState(false);
  const [isFeedbackModalVisible, setIsFeedbackModalVisible] = useState(false);
  const [feedbackContentKey, setFeedbackContentKey] = useState("");
  const [feedbackPost, setFeedbackPost] = useState("");
  const [feedbackSentContentKeys, setFeedbackSentContentKeys] = useState([]);
  const [downloadedContentKeys, setDownloadedContentKeys] = useState([]);
  const [sharePost, setSharePost] = useState();

  const swrOptions = {
    revalidateOnFocus: false,
  };
  const { data: getplaylistwithlikes } = useSWR(
    "/api/playlist/getplaylistwithlikes",
    fetcher,
    swrOptions
  );
  const { data: lookup } = useSWR("/api/lookup", fetcher, swrOptions);
  const { data: feedbacks } = useSWR(
    ["/api/Comment/Query", constants.commentTypes.feedback],
    commentsFetcher
  );
  const userLikes = getplaylistwithlikes?.userLikes || [];
  const playlists = getplaylistwithlikes?.playlists || null;

  const canProceed = useCallback(() => {
    if (isAuthenticated) {
      return true;
    }
    return false;
  }, [isAuthenticated]);

  const showShareModal = (post) => {
    setSharePost(post);
    setIsShareModalVisible(true);
  };

  const showFeedbackModal = (post) => {
    setFeedbackPost(post);
    setFeedbackContentKey(post.contentKey);
    setIsFeedbackModalVisible(true);
  };

  const closeFeedbackModal = () => {
    setFeedbackPost("");
    setFeedbackContentKey("");
    setIsFeedbackModalVisible(false);
  };

  const feedbackSent = () => {
    if (!feedbackSentContentKeys.includes(feedbackContentKey)) {
      setFeedbackSentContentKeys([
        ...feedbackSentContentKeys,
        feedbackContentKey,
      ]);
    }
    setFeedbackContentKey("");
    setIsFeedbackModalVisible(false);
    setShowFeedbackAlert(false);
    document.querySelector("body").classList.remove("overflow-hidden");
  };

  return (
    <>
      <div id={'rightpanel'} className={`${openSideBar ? "rightpanel" : "rightpanel-full"}`}>
        <div className="container mx-auto px-4">
          <div className="flex -mx-5 justify-center">
            <div
              className="w-full lg:flex-1 px-4 lg:px-8"
              style={{ maxWidth: "730px" }}
            >
              {content &&
                content.length > 0 &&
                content.map((item, index) => (
                  <VerbatimCard
                    key={item.id + "_" + index}
                    item={item}
                    index={index}
                    book={book}
                    userLikes={userLikes}
                    lookup={lookup}
                    playlists={playlists}
                    feedbacks={feedbacks}
                    showShareModal={showShareModal}
                    canProceed={canProceed}
                    isAuthenticated={isAuthenticated}
                    showFeedbackModal={showFeedbackModal}
                    feedbackSentContentKeys={feedbackSentContentKeys}
                    propGroup={{
                      downloadedContentKeys,
                      setDownloadedContentKeys,
                    }}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
      {isShareModalVisible && (
        <ShareModal
          post={sharePost}
          onClose={() => setIsShareModalVisible(false)}
        />
      )}
      {isFeedbackModalVisible && (
        <Modal onClose={closeFeedbackModal}>
          <FeedbackForm
            post={feedbackPost}
            contentKey={feedbackContentKey}
            onSubmit={() => feedbackSent()}
            feedbacks={feedbacks}
          />
        </Modal>
      )}
      {showFeedbackAlert && (
        <FeedbackBanner
          setShowFeedbackAlert={setShowFeedbackAlert}
          setIsFeedbackModalVisible={setIsFeedbackModalVisible}
        />
      )}
    </>
  );
};

export default RightPanel;
